var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[(!_vm.noNavRoutes.includes(_vm.$route.path))?_c('Navigation'):_vm._e(),(!_vm.noNavRoutes.includes(_vm.$route.path))?_c('StatusBar'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }